export default "__VITE_ASSET__e4a145e6__"